import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useDispatch, useSelector } from "react-redux";
import { deleteNotification } from "../../redux/notifications/notificationActions";

// Close icon component
const CloseIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const NotificationCard = ({ title, content, id }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  
  const deleteNotif = () => {
    dispatch(deleteNotification(user.currentUser.user._id, id, user.currentUser.token));
  };

  return (
    <Card className="max-w-full shadow-lg rounded-lg p-2 h-30 mx-3 my-2">
      <CardContent className="relative pt-2">
        <Button
          variant="ghost"
          size="icon"
          className="absolute top-2 right-2 h-6 w-6"
          onClick={deleteNotif}
        >
          <CloseIcon />
        </Button>
        <h3 className="text-lg font-semibold mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-600 mt-1">
          {content}
        </p>
      </CardContent>
    </Card>
  );
};

export default NotificationCard;